module.exports = __webpack_public_path__ + "static/media/1.8f6a20da.jpg";